/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSON, FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSON, } from './FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse';
import { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON, } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Data': FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseToJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Data': FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse.js.map